import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

import { setClusterMinMaxTasks as setClusterMinMaxTasksDiagram, getClusterMinMaxTasks as getClusterMinMaxTasksDiagram } from '@process-advisor/process-miner/processMiner/processMiner';


export type MinMaxProps = ApiMethodBase & {
    min: number;
    max: number;
};

export const setClusterMinMaxTasks = ({
    min,
    max,
}: MinMaxProps) => {
    setClusterMinMaxTasksDiagram({min, max});
    apiProvider.updateDiagramCluster({source : 'setClusterMinMaxTasks'});
};


export const getClusterMinMaxTasks = (): MinMaxProps => getClusterMinMaxTasksDiagram();


